<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16.002"><defs><clipPath id="7s4xmusqfa"><path d="M-1575 22156.992h-14v-16h10.009l3.993 3.992v12.006z" style="fill:#ac6e6e" transform="translate(2180 -21795)" fill="currentColor"/></clipPath></defs><g style="opacity:.6"><path d="M18896 19784.01h-12a1 1 0 0 1-1-1v-14a1 1 0 0 1 1-1h8v4a1 1 0 0 0 1 1h4v10a1 1 0 0 1-1 1zm-9-6.01v1.4h6v-1.4h-6zm0-3v1.4h6v-1.4h-6zm0-3v1.4h3v-1.4h-3z" style="fill:#333" transform="translate(-18882 -19768.008)" fill="currentColor"/><g style="clip-path:url(#7s4xmusqfa)" transform="translate(-589.998 -345.992)"><path d="M0 0h4v4H0z" style="fill:#333" transform="translate(601 345.992)" fill="currentColor"/></g></g></svg>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ri-summary',
});
</script>
